import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import CodeBlock from "./CodeBlock";
import { jsCode, pyCode } from "../constants/data";
import Avatar from "./Avatar";
import SelectComponent from "./SelectComponent";

const data = [
  {
    name: "Javascript",
    code: "js",
    value: jsCode,
  },
  {
    name: "Python",
    code: "js",
    value: pyCode,
  },
];

function Introduction() {
  const [languageData, setLanguageData] = useState(data[0]);

  return (
    <Box my={4}>
      <Typography
        variant="h4"
        className="md:text-2xl text-base font-['monospace'] text-center"
      >
        Hello, I'm <span className="line-through">Ajay</span> 😎 Ajax
      </Typography>
      <Typography
        className="m-6 md:text-base text-xs font-['monospace'] text-center"
        variant="subtitle1"
      >
        I'm a Software developer with experience of building dynamic, responsive
        websites , web applications and machine learning models.
      </Typography>
      <div className="text-center">
        <Avatar />
      </div>
      <SelectComponent
        className="flex items-center m-4 justify-end"
        value={languageData}
        setValue={setLanguageData}
        data={data}
      />
      <CodeBlock className={`language-${languageData.code}`} lang>
        {languageData.value}
      </CodeBlock>
    </Box>
  );
}

const Content = () => {
  return (
    <div>
      <Introduction />
      <p className="text-center mb-2">Made with 💓 by Ajay</p>
    </div>
  );
};

export default Content;
